module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/oYQPf8/tc-custom/9781488065996.jpg?1720280763940",
      "alt": "This image is the cover for the book Protected by the Knight's Proposal"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Protected by the Knight's Proposal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("His ring will protect her…"), _c('br'), _c('br')]), _c('b', [_c('i', [_vm._v("And expose his guarded heartWidowed Lady Cecily has a dangerous plan to secure her family’s future and their safety. A plan that is perfect, right until Lachlan of Drummuir discovers it! Cecily’s sure the honest and brooding warrior will expose her, despite their unexpected and powerful chemistry. But when she’s sent to the king for judgment, Lachlan shocks her by offering the ultimate protection—his hand in name only…")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Meriel Fuller\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Meriel Fuller spent her early childhood with her nose buried in books. After school, she would walk to the town library where her mother was head librarian and happily read her way through the historical romance section. Although Meriel had always written as a hobby, it was only when her youngest child was a toddler that she decided to write a historical romance of her own and was thrilled when Harlequin told her that her manuscript would be published: a real dream come true!")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0